import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'
import { EditOfferDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { idParams, useModalSlot } from '@/components/custom/modal-slot'
import EditOfferDialog from '@/routes/_app/-dialogs/edit-offer'

export const Route = createFileRoute('/@modal/offers/$offerId/edit')({
  params: idParams('offerId'),
  staticData: { slotScope: '/_app' },
  loader: ({ params, context }) => {
    // query: direct the offer form keys its own read (it also edits the selected offer); no route owns a dialog's key
    // prefetch: speculative warms that read on intent, before the click opens the form
    context.queryClient.query(trpc.jobs.getJob.queryOptions({ jobId: Number(params.offerId) })).catch(noop)
  },
  pendingComponent: EditOfferDialogPending,
  component: EditOfferSlot,
})

function EditOfferSlot() {
  const { params, ...slot } = useModalSlot(Route)
  return <EditOfferDialog offerId={Number(params.offerId)} {...slot} />
}
